import { call, put, takeEvery } from "redux-saga/effects";
import * as types from "./TenantManagementActionType";
import * as actions from "./TenantManagementActions";
import * as services from "./TenantManagementServices";
import SweetAlert from "../../../components/sweetalert/SweetAlert";

// Sfetch tenant management data
function* fetchTenantManagementSaga() {
  try {
    const response = yield call(services.fetchTenantManagementService);
    yield put(actions.fetchTenantManagementSuccess(response?.values || []));
  } catch (error) {
    const errorMessage = error?.message || "Failed to fetch tenant management";
    yield put(actions.fetchTenantManagementFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
      showConfirmButton: true,
    });
  }
}

// fetch get by id tenant management

function* fetchTenantByIdSaga(action) {
  try {
    const response = yield call(services.getTenantByIdService, action.payload);
    // Dispatch the correct success action
    yield put(actions.getTenantByIdSuccess(response?.values || {}));
  } catch (error) {
    const errorMessage = error?.message || "Failed to fetch tenant by ID";
    yield put(actions.getTenantByIdFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
      showConfirmButton: true,
    });
  }
}

//Get AllMasterTenantsTypes DD Saga

function* fetchAllMasterTenantTypesSaga() {
  try {
    const response = yield call(services.getAllMasterTenantTypesService);
    yield put(actions.getAllMasterTenantTypesSuccess(response?.values || []));
  } catch (error) {
    const errorMessage =
      error?.message || "Failed to fetch master tenant types";
    yield put(actions.getAllMasterTenantTypesFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
      showConfirmButton: true,
    });
  }
}

// Tenant Management Save Saga
function* saveTenantSaga(action) {
  try {
    const response = yield call(services.saveTenantService, action.payload);

    if (response?.success) {
      yield put(actions.saveTenantSuccess(response));

      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Tenant saved successfully.",
      });

      // const tenantId = action.payload?.TenantId || response?.values?.TenantId;

      // if (tenantId) {
      //     yield put(actions.getTenantByIdRequest(tenantId));
      // }
    } else {
      // Save failed (API-level failure)
      const errorMessage = response?.errorMessage || "Failed to save tenant";

      yield put(actions.saveTenantFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error?.response?.data?.errorMessage ||
      error?.message ||
      "Failed to save tenant";
    yield put(actions.saveTenantFailure(errorMessage));
    SweetAlert.error({ title: "Error!", text: errorMessage });
  }
}

//Storage Category DropDown Saga

function* fetchStorageCategoryDropdownSaga() {
  try {
    const response = yield call(services.getStorageCategoryDropdownService);
    yield put(
      actions.getStorageCategoryDropdownSuccess(response?.values || []),
    );
  } catch (error) {
    const errorMessage =
      error?.message || "Failed to fetch storage category dropdown";
    yield put(actions.getStorageCategoryDropdownFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
      showConfirmButton: true,
    });
  }
}

//Get All Master Country DropDowns Saga

function* fetchAllMasterCountrySaga() {
  try {
    const response = yield call(services.getAllMasterCountryService);
    yield put(actions.getAllMasterCountrySuccess(response?.values || []));
  } catch (error) {
    const errorMessage =
      error?.message || "Failed to fetch master country dropdowns";
    yield put(actions.getAllMasterCountryFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
      showConfirmButton: true,
    });
  }
}

// Get All Master Timezone Dropdown Saga

function* fetchAllMasterTimeZoneSaga() {
  try {
    const response = yield call(services.getAllMasterTimeZoneService);
    const timeZones = response?.values?.lstGetAllMasterTimeZones || [];
    yield put(actions.getAllMasterTimeZoneSuccess(timeZones));
  } catch (error) {
    const errorMessage =
      error?.message || "Failed to fetch master timezone dropdowns";
    yield put(actions.getAllMasterTimeZoneFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
      showConfirmButton: true,
    });
  }
}

// Activate Deactivate Tenant Management Saga

function* activateDeactivateTenantSaga(action) {
  try {
    const { tenantId, isActive } = action.payload;
    const response = yield call(
      services.activateDeactivateTenantService,
      tenantId,
      isActive,
    );
    if (response?.success) {
      yield put(actions.activateDeactivateTenantSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text:
          response?.resultMessage ||
          `Tenant has been ${isActive ? "activated" : "deactivated"} successfully.`,
      });

      yield put(actions.fetchtenantManagementRequest());
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to update tenant status";
      yield put(actions.activateDeactivateTenantFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error?.response?.data?.errorMessage ||
      error?.message ||
      "Failed to update tenant status";
    yield put(actions.activateDeactivateTenantFailure(errorMessage));
    SweetAlert.error({ title: "Error!", text: errorMessage });
  }
}

function* deleteTenantSaga(action) {
  try {
    const { tenantId, modifiedBy } = action.payload;
    const response = yield call(
      services.deleteTenantService,
      tenantId,
      modifiedBy,
    );
    if (response?.success) {
      yield put(actions.deleteTenantSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Tenant deleted successfully.",
      });

      yield put(actions.fetchtenantManagementRequest());
    } else {
      const errorMessage = response?.errorMessage || "Failed to delete tenant";
      yield put(actions.deleteTenantFailure(errorMessage));
      SweetAlert.error({
        title: "Error!",
        text: errorMessage,
      });
    }
  } catch (error) {
    const errorMessage =
      error?.response?.data?.errorMessage ||
      error?.message ||
      "Failed to delete tenant";
    yield put(actions.deleteTenantFailure(errorMessage));
    SweetAlert.error({ title: "Error!", text: errorMessage });
  }
}

// Get Default Tenant Configuration Saga
function* fetchDefaultTenantConfigSaga(action) {
  try {
    const response = yield call(
      services.getDefaultTenantConfigService,
      action.payload,
    );
    if (response?.success) {
      yield put(actions.getDefaultTenantConfigSuccess(response?.values || null));
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to fetch tenant configuration";
      yield put(actions.getDefaultTenantConfigFailure(errorMessage));
      SweetAlert.error({ title: "Error!", text: errorMessage });
    }
  } catch (error) {
    const errorMessage =
      error?.response?.data?.errorMessage ||
      error?.message ||
      "Failed to fetch tenant configuration";
    yield put(actions.getDefaultTenantConfigFailure(errorMessage));
    SweetAlert.error({ title: "Error!", text: errorMessage });
  }
}

// Save Default Tenant Configuration Saga
function* saveDefaultTenantConfigSaga(action) {
  try {
    const response = yield call(
      services.saveDefaultTenantConfigService,
      action.payload,
    );
    if (response?.success) {
      yield put(actions.saveDefaultTenantConfigSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Tenant configuration saved successfully.",
      });
    } else {
      const errorMessage =
        response?.errorMessage || "Failed to save tenant configuration";
      yield put(actions.saveDefaultTenantConfigFailure(errorMessage));
      SweetAlert.error({ title: "Error!", text: errorMessage });
    }
  } catch (error) {
    const errorMessage =
      error?.response?.data?.errorMessage ||
      error?.message ||
      "Failed to save tenant configuration";
    yield put(actions.saveDefaultTenantConfigFailure(errorMessage));
    SweetAlert.error({ title: "Error!", text: errorMessage });
  }
}

function* TenantManagementSaga() {
  yield takeEvery(types.TENANTMANAGEMENT_REQUEST, fetchTenantManagementSaga);
  yield takeEvery(types.GET_TENANT_BY_ID_REQUEST, fetchTenantByIdSaga);
  yield takeEvery(
    types.GET_ALL_MASTER_TENANT_TYPES_REQUEST,
    fetchAllMasterTenantTypesSaga,
  );
  yield takeEvery(types.SAVE_TENANT_REQUEST, saveTenantSaga);
  yield takeEvery(
    types.GET_STORAGE_CATEGORY_DROPDOWN_REQUEST,
    fetchStorageCategoryDropdownSaga,
  );
  yield takeEvery(
    types.GET_ALL_MASTER_COUNTRY_REQUEST,
    fetchAllMasterCountrySaga,
  );
  yield takeEvery(
    types.GET_ALL_MASTER_TIMEZONE_REQUEST,
    fetchAllMasterTimeZoneSaga,
  );
  yield takeEvery(
    types.ACTIVATE_DEACTIVATE_TENANT_REQUEST,
    activateDeactivateTenantSaga,
  );
  yield takeEvery(types.DELETE_TENANT_REQUEST, deleteTenantSaga);
  yield takeEvery(
    types.GET_DEFAULT_TENANT_CONFIG_REQUEST,
    fetchDefaultTenantConfigSaga,
  );
  yield takeEvery(
    types.SAVE_DEFAULT_TENANT_CONFIG_REQUEST,
    saveDefaultTenantConfigSaga,
  );
}

export default TenantManagementSaga;
